export default class NewUserModel {
    displayName: string = "";
    userName: string = "";    
    IsAdmin: boolean = false;

}